import React from 'react';

/**
 * Enhanced status indicator for the LiveChat conversation.
 * Shows contextual status messages with icons, colors, and pulse animations.
 */
const StatusDisplay = ({ currentState, isVisible }) => {
  const getStatusInfo = () => {
    switch (currentState) {
      case 'pre_processing':
        return {
          icon: '\uD83D\uDD04',
          text: 'Verwerken van je vraag...',
          subtext: 'Even geduld, we bereiden alles voor',
          color: '#FF9800',
          pulse: true
        };
      case 'user_speaking':
        return {
          icon: '\uD83C\uDFA4',
          text: 'Je spreekt...',
          subtext: 'Jesse luistert naar je',
          color: '#10b981',
          pulse: true
        };
      case 'transcribing':
        return {
          icon: '\uD83D\uDCDD',
          text: 'Jesse begrijpt wat je zegt...',
          subtext: 'Spraak wordt omgezet naar tekst',
          color: '#0d9488',
          pulse: true
        };
      case 'thinking':
        return {
          icon: '\uD83E\uDDE0',
          text: 'Jesse denkt na...',
          subtext: 'Antwoord wordt voorbereid',
          color: '#FF9800',
          pulse: true
        };
      case 'generating':
        return {
          icon: '\u270D\uFE0F',
          text: 'Jesse formuleert antwoord...',
          subtext: 'Bijna klaar!',
          color: '#0f766e',
          pulse: true
        };
      case 'listening':
        return {
          icon: '\uD83D\uDC42',
          text: 'Jesse luistert naar je...',
          subtext: 'Praat maar gewoon!',
          color: '#10b981',
          pulse: true
        };
      case 'processing':
        return {
          icon: '\uD83E\uDDE0',
          text: 'Jesse verwerkt je vraag...',
          subtext: 'Even geduld',
          color: '#0d9488',
          pulse: false
        };
      case 'responding':
        return {
          icon: '\uD83D\uDCAC',
          text: 'Jesse geeft antwoord...',
          subtext: 'Luister maar mee',
          color: '#FF9800',
          pulse: false
        };
      case 'generating_vacancy':
        return {
          icon: '\uD83D\uDCDD',
          text: 'Jesse stelt de volledige vacaturetekst op...',
          subtext: 'Dit kan 30-60 seconden duren',
          color: '#0f766e',
          pulse: true
        };
      case 'ready':
        return {
          icon: '\u2728',
          text: 'Jesse wacht op je volgende vraag',
          subtext: 'Praat wanneer je wilt!',
          color: '#10b981',
          pulse: false
        };
      default:
        return null;
    }
  };

  if (!isVisible) return null;

  const status = getStatusInfo();
  if (!status) return null;

  return (
    <div className="enhanced-status-display">
      <div className={`status-icon ${status.pulse ? 'pulse' : ''}`} style={{ color: status.color }}>
        {status.icon}
      </div>
      <div className="status-content">
        <div className="status-main-text">{status.text}</div>
        <div className="status-sub-text">{status.subtext}</div>
      </div>
    </div>
  );
};

export default StatusDisplay;
